import { usePrimaryFill } from '../../hooks/usePrimaryFill';
import styles from './TopButton.module.css';

interface TopButtonProps {
  label: string;
  onClick: () => void;
  primaryColor?: string;
  primaryHoverColor?: string;
  useGradient?: boolean;
  emoji?: string;
}

export function TopButton({ label, onClick, primaryColor, primaryHoverColor, useGradient = false, emoji }: TopButtonProps) {
  const { style, onMouseEnter, onMouseLeave } = usePrimaryFill(
    primaryColor,
    primaryHoverColor,
    useGradient,
  );

  const isImageEmoji = emoji && (emoji.startsWith('http') || emoji.startsWith('/'));

  return (
    <div className={styles.wrapper}>
      <button
        className={styles.topButton}
        onClick={onClick}
        style={style}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {emoji && (
          isImageEmoji ? (
            <img src={emoji} alt="" className={styles.emojiImg} />
          ) : (
            <span className={styles.emoji}>{emoji}</span>
          )
        )}
        <span className={styles.label}>{label}</span>
      </button>
    </div>
  );
}
